import  gql  from 'graphql-tag'

export const modules = gql`query {
    modules {
        edges {
            node {
            id
            appLabel
            model
            name
            permissionSet {
                edges {
                node {
                    id
                    name
                    codename
                }
                }
            }
            }
        }
        }
    }`;
